import { AysCodeCodingSystem } from '@bindoc-projects/code-domain-lib';

export class AysCodesStore {
  constructor(private readonly _baseUrl: string) {}

  public codingSystem(codingSystem: AysCodeCodingSystem): string {
    return `${this._codingSystemUrl(codingSystem)}/`;
  }

  public children(codingSystem: AysCodeCodingSystem): string {
    const baseUrl = `${this._codingSystemUrl(codingSystem)}/`;

    return `${baseUrl}children/`;
  }

  public codeGroup(codingSystem: AysCodeCodingSystem): string {
    const baseUrl = this._baseUrl;

    if (codingSystem === 'G-DRG') {
      return `${baseUrl}/${codingSystem}/mdc-groups/`;
    } else if (codingSystem === 'ICD-10-GM' || codingSystem === 'ICD-10-AT') {
      return `${baseUrl}/${codingSystem}/chapters/`;
    } else {
      return `${baseUrl}/${codingSystem}/groups/`;
    }
  }

  public codeByCodeName(
    codingSystem: AysCodeCodingSystem,
    codeName: string,
  ): string {
    return `${this._codingSystemUrl(codingSystem)}/${codeName}`;
  }

  public codeAgeGroupDistribution(
    codingSystem: AysCodeCodingSystem,
    codeName: string,
  ): string {
    return `${this._codingSystemUrl(codingSystem)}/${codeName}/cases/agm-id/distribution`;
  }

  public codePrevalence(
    codingSystem: AysCodeCodingSystem,
    codeName: string,
  ): string {
    return `${this._codingSystemUrl(codingSystem)}/${codeName}/cases/prevalence`;
  }

  public treeParent(
    codingSystem: AysCodeCodingSystem,
    codeName: string,
  ): string {
    return `${this._codingSystemUrl(codingSystem)}/tree/${codeName}`;
  }

  public treePaths(codingSystem: AysCodeCodingSystem): string {
    return `${this._codingSystemUrl(codingSystem)}/tree/paths`;
  }

  public treeChildren(codingSystem: AysCodeCodingSystem): string {
    return `${this._codingSystemUrl(codingSystem)}/tree/children`;
  }

  private _codingSystemUrl(codingSystem: AysCodeCodingSystem): string {
    const baseUrl = this._baseUrl;

    return `${baseUrl}/${codingSystem}`;
  }
}
